import enTravelCari from './locales/en/travelCari.json';
import trTravelCari from './locales/tr/travelCari.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enSidebar from './locales/en/sidebar.json';
import enSettings from './locales/en/settings.json';
import enCustomers from './locales/en/customers.json';
import enBookings from './locales/en/bookings.json';
import enPackages from './locales/en/packages.json';
import enPartners from './locales/en/partners.json';
import enQuotes from './locales/en/quotes.json';
import enHotels from './locales/en/hotels.json';
import enAccounting from './locales/en/accounting.json';
import enInvoices from './locales/en/invoices.json';
import enExpenses from './locales/en/expenses.json';
import enAllocations from './locales/en/allocations.json';
import enReconciliation from './locales/en/reconciliation.json';
import enFiscalPeriods from './locales/en/fiscalPeriods.json';
import enPaymentPlans from './locales/en/paymentPlans.json';
import enPromoCodes from './locales/en/promoCodes.json';
import enReviews from './locales/en/reviews.json';
import enTrading from './locales/en/trading.json';
import enNotifications from './locales/en/notifications.json';
import enOperations from './locales/en/operations.json';
import enTradingAccounting from './locales/en/tradingAccounting.json';
import enActivityFeed from './locales/en/activityFeed.json';
import enPostingRules from './locales/en/postingRules.json';
import enTieOut from './locales/en/tieOut.json';
import enPeriodEnd from './locales/en/periodEnd.json';
import trCommon from './locales/tr/common.json';
import trDashboard from './locales/tr/dashboard.json';
import trSidebar from './locales/tr/sidebar.json';
import trSettings from './locales/tr/settings.json';
import trCustomers from './locales/tr/customers.json';
import trBookings from './locales/tr/bookings.json';
import trPackages from './locales/tr/packages.json';
import trPartners from './locales/tr/partners.json';
import trQuotes from './locales/tr/quotes.json';
import trHotels from './locales/tr/hotels.json';
import trAccounting from './locales/tr/accounting.json';
import trInvoices from './locales/tr/invoices.json';
import trExpenses from './locales/tr/expenses.json';
import trAllocations from './locales/tr/allocations.json';
import trReconciliation from './locales/tr/reconciliation.json';
import trFiscalPeriods from './locales/tr/fiscalPeriods.json';
import trPaymentPlans from './locales/tr/paymentPlans.json';
import trPromoCodes from './locales/tr/promoCodes.json';
import trReviews from './locales/tr/reviews.json';
import trTrading from './locales/tr/trading.json';
import trNotifications from './locales/tr/notifications.json';
import trOperations from './locales/tr/operations.json';
import trTradingAccounting from './locales/tr/tradingAccounting.json';
import trActivityFeed from './locales/tr/activityFeed.json';
import trPostingRules from './locales/tr/postingRules.json';
import trTieOut from './locales/tr/tieOut.json';
import trPeriodEnd from './locales/tr/periodEnd.json';

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    sidebar: enSidebar,
    settings: enSettings,
    customers: enCustomers,
    bookings: enBookings,
    packages: enPackages,
    partners: enPartners,
    quotes: enQuotes,
    hotels: enHotels,
    accounting: enAccounting,
    invoices: enInvoices,
    expenses: enExpenses,
    allocations: enAllocations,
    reconciliation: enReconciliation,
    fiscalPeriods: enFiscalPeriods,
    paymentPlans: enPaymentPlans,
    promoCodes: enPromoCodes,
    reviews: enReviews,
    trading: enTrading,
    travelCari: enTravelCari,
    notifications: enNotifications,
    operations: enOperations,
    tradingAccounting: enTradingAccounting,
    activityFeed: enActivityFeed,
    postingRules: enPostingRules,
    tieOut: enTieOut,
    periodEnd: enPeriodEnd,
  },
  tr: {
    common: trCommon,
    dashboard: trDashboard,
    sidebar: trSidebar,
    settings: trSettings,
    customers: trCustomers,
    bookings: trBookings,
    packages: trPackages,
    partners: trPartners,
    quotes: trQuotes,
    hotels: trHotels,
    accounting: trAccounting,
    invoices: trInvoices,
    expenses: trExpenses,
    allocations: trAllocations,
    reconciliation: trReconciliation,
    fiscalPeriods: trFiscalPeriods,
    paymentPlans: trPaymentPlans,
    promoCodes: trPromoCodes,
    reviews: trReviews,
    trading: trTrading,
    travelCari: trTravelCari,
    notifications: trNotifications,
    operations: trOperations,
    tradingAccounting: trTradingAccounting,
    activityFeed: trActivityFeed,
    postingRules: trPostingRules,
    tieOut: trTieOut,
    periodEnd: trPeriodEnd,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'dashboard', 'sidebar', 'settings', 'customers', 'bookings', 'packages', 'partners', 'quotes', 'hotels', 'accounting', 'invoices', 'expenses', 'allocations', 'reconciliation', 'fiscalPeriods', 'paymentPlans', 'promoCodes', 'reviews', 'trading', 'notifications', 'operations', 'tradingAccounting', 'activityFeed', 'postingRules', 'tieOut', 'periodEnd'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
